interface Props {
    className?: string
    FillColor?: string
}

export default function ChatBubbleInfo({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path
                d="M11.55 14.75C11.3843 14.75 11.25 14.6157 11.25 14.45V9.95C11.25 9.28726 11.7873 8.75 12.45 8.75C12.6157 8.75 12.75 8.88432 12.75 9.05V13.55C12.75 14.2127 12.2127 14.75 11.55 14.75Z"
                fill={FillColor} />
            <path
                d="M12.45 5.75C11.7873 5.75 11.25 6.28726 11.25 6.95V7.7C11.25 7.86569 11.3843 8 11.55 8C12.2127 8 12.75 7.46274 12.75 6.8V6.05C12.75 5.88431 12.6157 5.75 12.45 5.75Z"
                fill={FillColor} />
            <path
                d="M1.5 6.5C1.5 4.42893 3.17893 2.75 5.25 2.75H18.75C20.8211 2.75 22.5 4.42893 22.5 6.5V14C22.5 16.0711 20.8211 17.75 18.75 17.75H11.5606L7.5364 21.7743C6.96942 22.3412 6 21.9397 6 21.1379V17.75H5.25C3.17893 17.75 1.5 16.0711 1.5 14V6.5ZM5.25 4.25C4.00736 4.25 3 5.25736 3 6.5V14C3 15.2427 4.00736 16.25 5.25 16.25H6.6C7.09706 16.25 7.5 16.653 7.5 17.15V19.6893L10.6757 16.5136C10.8445 16.3448 11.0734 16.25 11.3121 16.25H18.75C19.9926 16.25 21 15.2427 21 14V6.5C21 5.25736 19.9926 4.25 18.75 4.25H5.25Z"
                fill={FillColor} />
        </svg>
    )
}
